import React from 'react';
import { LoadingButton } from '@mui/lab';
import BgModalUpgrade from '../../assets/images/bg-upgrade-modal.png';
import { px2rem } from '../../common/theme/px2rem';
import { planPriceButtonText } from '../../shared/utils/plan';
import useCreateCheckout from '../../hooks/use-create-checkout';
import { Link1, GrowBolt, Gear, ItemManager } from '@menuzen/icon/build/outline';
import Dialog, { DialogProps } from '../dialog/Dialog';
import { ACCOUNT_PLANS } from '@mnz/builder';

export interface AccountUpgradeModalProps extends DialogProps {
    cancelUrl: string;
    successUrl: string;
}

export const AccountUpgradeModal: React.FC<AccountUpgradeModalProps> = ({ cancelUrl, successUrl, ...props }) => {
    const { createCheckout, loading } = useCreateCheckout({
        cancelUrl,
        successUrl,
    });
    const handleSubmitUpgrade = () => {
        if (!loading) {
            createCheckout();
        }
    };

    return (
        <Dialog
            classes={{
                paper: '!pt-0',
            }}
            {...props}
            childClassName="flex flex-col flex-auto overflow-y-auto"
            headerStyle={{
                position: 'relative',
                top: 0,
                backgroundImage: `url(${BgModalUpgrade})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top left',
                paddingTop: px2rem(200),
            }}
            headerClassName={'flex w-full px-28  relative shrink-0 pt-20'}
            closeButtonClassName={'flex-shrink-0 text-24 text-primary-70 absolute right-28 top-15 cursor-pointer z-10'}
        >
            <div className={'flex flex-col flex-auto px-28 pt-20 pb-40 overflow-y-auto'}>
                <div className={'text-center'}>
                    <div
                        className={`inline-flex items-center justify-center text-white bg-gradient-upgrade-90 p-6 rounded`}
                    >
                        <GrowBolt />
                        <span className={`text-12`}>{ACCOUNT_PLANS.GROW.NAME}</span>
                    </div>
                </div>
                <h1 className={'font-bold my-15 text-25 text-center'}>Unlock Unlimited Access</h1>
                <p className={'text-center text-14 mb-20'}>
                    Upgrade to Menuzen Grow to unlock unlimited <br />
                    access to all of our features, including:
                </p>

                <div className={'p-2 rounded-6 bg-gradient-upgrade-90'}>
                    <div className={'p-20 text-14 leading-none font-semibold bg-white rounded-6 '}>
                        <div className={'flex items-center mb-16'}>
                            <div className={'mr-12 text-24'}>
                                <ItemManager />
                            </div>
                            Unlimited Menus, Items & Users
                        </div>
                        <div className={'flex items-center mb-16'}>
                            <div className={'mr-12 text-24'}>
                                <Gear />
                            </div>
                            Remove Menuzen Branding
                        </div>
                        <div className={'flex items-center'}>
                            <div className={'mr-12 text-24'}>
                                <Link1 />
                            </div>
                            Use a Custom URL
                            <span className={'text-10 ml-15 font-semibold rounded bg-primary-10 py-4 px-6'}>
                                COMING SOON
                            </span>
                        </div>
                    </div>
                </div>

                <div className={'text-center mt-15 mb-18'}>
                    <span className={'font-bold'}>Cancel any time</span> - We will never overcharge you.
                </div>
                <LoadingButton
                    loading={loading}
                    type="button"
                    onClick={handleSubmitUpgrade}
                    variant="contained"
                    classes={{
                        root: 'flex items-center justify-center cursor-pointer text-white px-28 py-10 !mb-15 text-16 rounded-round bg-gradient-upgrade-90',
                    }}
                    size="large"
                >
                    <GrowBolt className={'w-20 h-20'} />
                    <span>Upgrade for {planPriceButtonText(ACCOUNT_PLANS.GROW)}</span>
                </LoadingButton>

                <p className={'text-center text-10'}>
                    View our{' '}
                    <a
                        className={'font-bold underline'}
                        target={'_blank'}
                        href="https://www.menuzen.com/site-terms-conditions"
                        rel="noreferrer"
                    >
                        Terms & Conditions
                    </a>
                    <span>{` & `}</span>
                    <a
                        className={'font-bold underline'}
                        target={'_blank'}
                        href="https://www.menuzen.com/site-privacy-policy"
                        rel="noreferrer"
                    >
                        Privacy Policy.
                    </a>
                </p>
            </div>
        </Dialog>
    );
};
